export const SET_SCHEDULE_PERIODS_LOADED = "SET_SCHEDULE_PERIODS_LOADED";

export const setSchedulePeriodsLoaded = (schedulePeriodsLoaded: boolean) => {
  return {
    schedulePeriodsLoaded,
    type: SET_SCHEDULE_PERIODS_LOADED
  };
};
